<template>
  <hr class="border-t-thin border-[#EAECF0]" />
</template>
